<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<div class="left_option">
					<em class="lt_text mgr_5">Period Type </em>
					<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastWeek" /> Last Week</label>
					<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastMonth" /> Last Month</label>
					<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="ThisMonth" /> This Month</label>
					<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="ThisMonthLastYear" /> This Month of Last Year</label>
					<label><input type="radio" v-model="computedPeriod" value="Custom" />Custom</label>

					<span class="mgr_15">
						<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="from_date" /> ~
						<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="to_date" />
					</span>

					<em class="lt_text">Country </em>
					<span class="int_type_no_border mgr_15">
						<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="computedCountry" />
					</span>

					<span v-show="!display_by_sales_group">
						<em class="lt_text">State </em>
						<span class="int_type_no_border mgr_15">
							<CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" />
						</span>

						<em class="lt_text">Sales Group</em>
						<span class="int_type_no_border mgr_15"
							><CodeSelect className="tbl_select" :codes="restriction_only && state_report_filters ? state_report_filters.restrictionOnlySalesGroupList : salesGroups" :showDesc="false" v-model="sales_group_code"
						/></span>
					</span>

					<label class="mgr_15"><input type="checkbox" v-model="display_by_sales_group" @change="setDisplayBySalesGroup()" /><em class="lt_text"> Display by SalesGroup</em></label>

					<a href="javascript:;" class="search_bt mgr_5" @click="getSalesByState">Search</a>
					<span v-show="list_by_state && list_by_state.length">
						<a v-if="search_param && !search_param.display_by_sales_group" href="javascript:void(0);" class="gray_bt mgr_10" v-on:click="reportPrint">Print</a>
						<a href="javascript:void(0);" class="gray_bt" v-on:click="excelExport">Excel</a>
					</span>
				</div>

				<div v-show="display_by_sales_group" class="left_option">
					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border"><CodeSelect className="tbl_select" :codes="restriction_only && state_report_filters ? state_report_filters.restrictionOnlySalesGroupList : salesGroups" :showDesc="false" @set-code="setSalesGroupArr"/></span>
					<span class="int_type_no_border mgr_15">
						<input type="text" class="tbl_int" v-model.trim="sales_group_string" style="width:300px;" placeholder="Select Multiple Sales Group" />
					</span>

					<em class="lt_text">Salesman</em>
					<span class="int_type_no_border mgr_15"><CodeSelect className="tbl_select" :codes="salesmansForSearch" :showDesc="false" v-model="salesman_id"/></span>

					<em class="lt_text mgl_15">State</em>
					<span class="int_type_no_border"><CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" @set-code="setStateArr"/></span>
					<span class="int_type_no_border">
						<input type="text" class="tbl_int" v-model.trim="state_string" style="width:300px;" placeholder="Select Multiple State" />
					</span>
				</div>

				<SelectPartners :restrictionOnly="restriction_only" :delim="separator" v-model="partner_string" />
			</div>
		</div>

		<CommonTable :tbl_headers="tbl_headers" :data="display_records" @sort="sort" :sort_key="sort_key" :sort_direction="sort_direction" @onClickGS="onClickGS" @onClickR="onClickR" @onClickNS="onClickNS" />
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import SelectPartners from '@/components/common/SelectPartners';
import { apiSalesByState } from '@/api/report/report';
import { apiIndex } from '@/api/partner/index.js';
import { toText } from '@/utils/date';
import { fixDecimalPlace } from '@/utils/etc';
import { exportDataExcel, apiGetReportTemplate, Report, reportMrtUrl, PrintType, objectCopy } from '@/api/util';
import { inputSelectOnClick } from '@/utils/etc.js';
import { defaultDataType } from 'export-xlsx';
export default {
	mixins: [stateReport({ id: 'SalesByState', search: 'getSalesByState', queries: ['getSalesByState'], results: ['display_records', 'list_by_state', 'search_param', 'tbl_headers'] })],
	data: () => ({
		from_date: null,
		to_date: null,
		country: null,
		state: null,
		sales_group_code: null,
		partner_string: null,
		sales_group_string: null,
		state_string: null,
		sort_key: null,
		sort_direction: null,
		display_by_sales_group: false,
		salesman_id: null,

		search_param: {},
		list_by_state: [],

		countries: [],
		states: [],
		salesGroups: [],
		salesmans: [],

		period: null,
		separator: ',',

		tbl_headers: [],
		display_records: [],
	}),
	components: {
		CommonTable,
		CustomDatePicker,
		CodeSelect,
		SelectPartners,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		computedPeriod: {
			get() {
				return this.period;
			},
			set(newValue) {
				this.period = newValue;
				this.changeFromNToDate();
			},
		},
		computedCountry: {
			get() {
				return this.country;
			},
			set(newValue) {
				this.emptyState();
				this.country = newValue;
			},
		},
		salesmansForSearch() {
			return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
		},
		filteredStates() {
			if (this.restriction_only && this.state_report_filters) return (this.state_report_filters.restrictionOnlyStateList || []).filter(state => !this.country || state.country === this.country);
			if (!this.country && this.user.company_id == 'newjigu') return this.states;
			return this.states.filter(s => s.country == this.country);
		},
		total_gross_sales() {
			let total = 0;
			this.list_by_state.forEach(el => (total += el.gross_sales));

			return total;
		},
		total_return_amt() {
			let total = 0;
			this.list_by_state.forEach(el => (total += el.return_amt));

			return total;
		},
		total_net_sales() {
			let total = 0;
			this.list_by_state.forEach(el => (total += el.net_sales));

			return total;
		},
		sales_group_arr() {
			return this.sales_group_string ? this.sales_group_string.split(this.separator) : [];
		},
		partner_arr() {
			return this.partner_string ? this.partner_string.split(this.separator) : [];
		},
		state_arr() {
			const arr = [];
			if (this.state_string) {
				const split_arr = this.state_string.split(this.separator);
				split_arr.forEach(el => {
					const idx = el.indexOf('(');
					arr.push({
						state: el.substring(0, idx),
						country: el.substring(idx + 1, el.length - 1),
					});
				});
			}

			return arr;
		},
	},
	methods: {
		onClickGS(r) {
			this.gotoInvoiceList('S', r.country, r.state);
		},
		onClickR(r) {
			this.gotoInvoiceList('R', r.country, r.state);
		},
		onClickNS(r) {
			this.gotoInvoiceList(null, r.country, r.state);
		},
		gotoInvoiceList(invoice_type, country, state) {
			let routeData = this.$router.resolve({
				name: 'invoiceMain',
				query: this.stateReportQuery({
					backUri: this.uri,
					invoice_type: invoice_type,
					invoice_date_from: this.from_date,
					invoice_date_to: this.to_date,
					country: country,
					state: state,
				}),
			});
			window.open(routeData.href, 'herp_invoice');
		},
		sort(header) {
			if (this.search_param.display_by_sales_group) return;
			const sort_key = header.key;

			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.getSalesByState();
		},
		setDisplayBySalesGroup() {},
		setSalesGroupArr(sg) {
			if (this.sales_group_arr.findIndex(el => el === sg.code) > -1) return;

			if (this.sales_group_string) this.sales_group_string += this.separator + sg.code;
			else this.sales_group_string = sg.code;
		},
		setStateArr(st) {
			if (this.state_arr.findIndex(el => el.country === this.country && el.state === st.code) > -1) return;

			if (this.state_string) this.state_string += this.separator + st.code + '(' + this.country + ')';
			else this.state_string = st.code + '(' + this.country + ')';
		},
		changeFromNToDate() {
			if (this.period === 'Custom') return;

			let today = new Date();
			let from_date = null;
			let to_date = null;

			if (this.period === 'LastWeek') {
				to_date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 1));
				from_date = new Date(to_date.getFullYear(), to_date.getMonth(), to_date.getDate() - 6);
			} else if (this.period === 'LastMonth') {
				to_date = new Date(today.getFullYear(), today.getMonth(), 0);
				from_date = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			} else if (this.period === 'ThisMonth') {
				to_date = today;
				from_date = new Date(today.getFullYear(), today.getMonth(), 1);
			} else if (this.period === 'ThisMonthLastYear') {
				to_date = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
				from_date = new Date(today.getFullYear() - 1, today.getMonth(), 1);
			}

			this.from_date = toText(from_date, '-');
			this.to_date = toText(to_date, '-');
		},
		excelExport() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (!this.list_by_state || !this.list_by_state.length) return this.$toast.error('No List To Export');
			if (!state_output.valid) return;
			exportDataExcel(this.display_records, this.tbl_headers, 'salesByState');
		},
		async reportPrint() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (this.search_param.display_by_sales_group) return;
			if (!this.list_by_state || !this.list_by_state.length) return this.$toast.error('No List To Be Shown');

			const data = {
				from_date: this.search_param.from_date || '',
				to_date: this.search_param.to_date || '',
				country: this.search_param.country || '',
				state: this.search_param.state || '',
				sales_group_code: this.search_param.sales_group_code || '',
				partner_string: Array.isArray(this.search_param.partner_arr) ? this.search_param.partner_arr.join(this.separator) : '',
				total_gross_sales: fixDecimalPlace(this.total_gross_sales, 2),
				total_return_amt: fixDecimalPlace(this.total_return_amt, 2),
				total_net_sales: fixDecimalPlace(this.total_net_sales, 2),
				list_by_state: this.list_by_state,
			};
			const reportTemplate = await apiGetReportTemplate('SalesByState', reportMrtUrl('SalesByState'));
			const report = new Report(reportTemplate, data, 'SalesByState', PrintType.Normal);
			this.$store.commit('setReport', { ...report, state_scope_context: state_output });
		},
		emptyState() {
			this.state = null;
		},
		async getSalesByState() {
			if (!this.from_date || !this.to_date) {
				this.$toast.error('Please, Input Date Range.');
				return;
			}

			const param = {
				from_date: this.from_date,
				to_date: this.to_date,
				display_by_sales_group: this.display_by_sales_group,
				partner_arr: this.partner_arr,
			};

			if (this.display_by_sales_group) {
				param.state_arr = this.state_arr;
				param.sales_group_arr = this.sales_group_arr;
				param.salesman_id = this.salesman_id || null;
				this.sort_key = null;
				this.sort_direction = null;
			} else {
				param.country = this.country || null;
				param.state = this.state || null;
				param.sales_group_code = this.sales_group_code || null;
				param.salesman_id = null;
				param.sort_key = this.sort_key || null;
				param.sort_direction = this.sort_direction || null;
			}

			const { data } = await apiSalesByState.call(this, param);
			this.list_by_state = data;
			this.search_param = objectCopy(param);

			const tbl_headers = this.setHeader();
			this.makeCommonTable(tbl_headers); // tbl_headers와 display_records Set
		},
		makeCommonTable(tbl_headers) {
			const merge_info = []; // SubTotal이 Country와 State별로 존재하므로 첫 행부터 행병합이 이루어짐.
			const merge_column = 'sales_group_code';
			const records = Array.isArray(this.list_by_state) ? [...this.list_by_state] : [];

			if (records.length > 0) {
				if (this.display_by_sales_group) {
					// state별 subTatal
					let prev = {};
					for (let i = 0; i < records.length; i++) {
						const el = records[i];

						if (prev.sales_group_code === el.sales_group_code) {
							if (merge_info[merge_info.length - 1].end) merge_info.push({ start: i });

							prev.gross_sales += el.gross_sales;
							prev.return_amt += el.return_amt;
							prev.net_sales += el.net_sales;
						} else {
							if (i > 0) {
								records.splice(i, 0, {
									sales_group_code: prev.sales_group_code,
									state: '',
									country: 'SubTotal',
									gross_sales: prev.gross_sales,
									return_amt: prev.return_amt,
									net_sales: prev.net_sales,
									cell_style: { country: ['al_right', 'bold_letter'] },
								});

								merge_info[merge_info.length - 1].end = i;

								prev = {
									sales_group_code: el.sales_group_code,
									gross_sales: 0,
									return_amt: 0,
									net_sales: 0,
								};
							} else {
								merge_info.push({ start: 0 });

								prev = {
									sales_group_code: el.sales_group_code,
									gross_sales: el.gross_sales,
									return_amt: el.return_amt,
									net_sales: el.net_sales,
								};
							}
						}
					}
					// 마지막 subtotal
					records.push({
						sales_group_code: prev.sales_group_code,
						state: '',
						country: 'SubTotal',
						gross_sales: prev.gross_sales,
						return_amt: prev.return_amt,
						net_sales: prev.net_sales,
						cell_style: { country: ['al_right', 'bold_letter'] },
					});

					merge_info[merge_info.length - 1].end = records.length - 1;

					// Grand Total
					records.push({
						is_colspan_record: true,
						sales_group_code: 'Grand Total',
						gross_sales: this.total_gross_sales,
						return_amt: this.total_return_amt,
						net_sales: this.total_net_sales,
						columns: [
							{ colspan: 3, key: 'sales_group_code', sales_group_code: 'Grand Total', td_class: ['al_right', 'bold_letter'] },
							{ colspan: 1, key: 'gross_sales', gross_sales: this.total_gross_sales, td_class: 'al_right', display_filter: 'toCurrency' },
							{ colspan: 1, key: 'return_amt', return_amt: this.total_return_amt, td_class: 'al_right', display_filter: 'toCurrency' },
							{ colspan: 1, key: 'net_sales', net_sales: this.total_net_sales, td_class: 'al_right', display_filter: 'toCurrency' },
						],
					});

					const idx = tbl_headers.findIndex(h => h.key === merge_column);
					if (idx > -1) tbl_headers[idx]['row_merge'] = merge_info;
				} else {
					let left_th = null;
					if (this.partner_arr.length > 0) left_th = { colspan: 4, key: 'code', code: 'Total', td_class: ['al_right', 'bold_letter'] };
					else left_th = { colspan: 2, key: 'country', country: 'Total', td_class: ['al_right', 'bold_letter'] };

					records.push({
						is_colspan_record: true,
						code: this.partner_arr.length > 0 ? 'Total' : '',
						country: this.partner_arr.length > 0 ? '' : 'Total',
						gross_sales: this.total_gross_sales,
						return_amt: this.total_return_amt,
						net_sales: this.total_net_sales,
						columns: [
							left_th,
							{ colspan: 1, key: 'gross_sales', gross_sales: this.total_gross_sales, td_class: 'al_right', display_filter: 'toCurrency' },
							{ colspan: 1, key: 'return_amt', return_amt: this.total_return_amt, td_class: 'al_right', display_filter: 'toCurrency' },
							{ colspan: 1, key: 'net_sales', net_sales: this.total_net_sales, td_class: 'al_right', display_filter: 'toCurrency' },
						],
					});
				}
			}

			this.tbl_headers = tbl_headers;
			this.display_records = records;
		},
		defaultHeader() {
			const header = [
				{ key: 'country', name: 'Country', tbl_width: '20%', td_class: 'al_center', width: 15, dataType: defaultDataType.string },
				{ key: 'state', name: 'State', tbl_width: '20%', td_class: 'al_center', width: 15, dataType: defaultDataType.string },
				{ key: 'gross_sales', name: 'Gross Sales Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number, click_event: 'onClickGS' },
				{ key: 'return_amt', name: 'Return Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number, click_event: 'onClickR' },
				{ key: 'net_sales', name: 'Net Sales Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number, click_event: 'onClickNS' },
			];

			return header;
		},
		partnerHeader() {
			const header = [
				{ key: 'code', name: 'Partner Code', tbl_width: '10%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Partner Name', tbl_width: '15%', td_class: 'al_left', width: 25, dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', tbl_width: '15%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'state', name: 'State', tbl_width: '15%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'gross_sales', name: 'Gross Sales Amt.($)', tbl_width: '15%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
				{ key: 'return_amt', name: 'Return Amt.($)', tbl_width: '15%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
				{ key: 'net_sales', name: 'Net Sales Amt.($)', tbl_width: '15%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
			];

			return header;
		},
		salesGroupHeader() {
			const header = [
				{ key: 'sales_group_code', name: 'Sales Group', tbl_width: '10%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'state', name: 'State', tbl_width: '10%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', tbl_width: '20%', td_class: 'al_left', width: 15, dataType: defaultDataType.string },
				{ key: 'gross_sales', name: 'Gross Sales Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
				{ key: 'return_amt', name: 'Return Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
				{ key: 'net_sales', name: 'Net Sales Amt.($)', tbl_width: '20%', td_class: 'al_right', th_click_event: 'sort', display_filter: 'toCurrency', width: 15, dataType: defaultDataType.number },
			];

			return header;
		},
		setHeader() {
			if (this.display_by_sales_group) return this.salesGroupHeader();
			else if (this.partner_arr.length > 0) return this.partnerHeader();
			else return this.defaultHeader();
		},
		async index() {
			const { data } = await apiIndex();

			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
		},
		async init() {
			if (this.user.company_id == 'newjigu') this.computedPeriod = 'ThisMonth';
			else this.computedPeriod = 'LastMonth';
			this.$nextTick(() => inputSelectOnClick());

			await this.index();
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesByState');
		this.$store.commit('setSubTitle', 'Report -> Sales by State');

		this.init();
	},
};
</script>

<style></style>
